<template>
  <div>
    <div class="flex flex-wrap filtr-container">
      <div
        v-for="(item, index) in selectedImages"
        :key="index"
        class="w-full lg:w-1/3 p-4 text-center"
      >
        <div @click="openModal(index + 1)">
          <RePictureSet
            :image="item"
            image-class="gallery-thumb img-fluid img-shadow lazyload"
            sizes="180px"
          />
        </div>
      </div>
    </div>
    <ReModal
      :show-if="ismodal"
      :has-buttons="false"
      :is-transparent="true"
      :half="true"
    >
      <template #default>
        <img
          class="absolute right-[22px] p-2 cursor-pointer bg-gray bg-opacity-80"
          src="/img/close_icon.svg"
          alt=""
          @click="closeModal"
        >

        <transition
          name="fade"
          mode="out-in"
        >
          <div
            v-for="(item, index2) in slideImages"
            :key="index2"
            class=""
          >
            <img
              :src="item.url"
              class="img-fluid"
            >
            <div class="text-center text-white text-2xl">
              <p>
                {{ slideIndex }} / {{ selectedImages.length }}
              </p>
            </div>
          </div>
        </transition>
        <a
          v-if="selectedImages.length > 1"
          class="top-[50%] mt-[-50px] lg:left-[-35px] absolute cursor-pointer p-[10px] text-white text-4xl"
          @click="plusSlides(-1)"
        >
          <img
          
            src="/img/event_gallery_left_icon.svg"
            class="h-[30px]"
            alt=""
          >
        
        </a>
        <a
          v-if="selectedImages.length > 1"
          class="top-[50%] mt-[-50px] right-[22px] lg:right-[-35px] absolute cursor-pointer p-[10px] text-white text-4xl"
          @click="plusSlides(1)"
        >
          <img
            class="h-[30px]"
            src="/img/event_gallery_right_icon.svg"
            alt=""
          >
        </a>
      </template>
    </ReModal>
  </div>
</template>
<script>
import ReModal from '~/components/rxt/recomponent/ReModal.vue'
import RePictureSet from '~/components/rxt/recomponent/RePictureSet.vue'
export default {
  components: {
    ReModal,RePictureSet
  },
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      slideIndex: 1,
      ismodal: false,
      selectedCategory: "all"
    };
  },
  computed: {
    slideImages() {
      return this.selectedImages.filter((value, index) => {
        return index + 1 === this.slideIndex;
      });
    },
    selectedImages() {
      if (this.selectedCategory === "all") {
        return this.images;
      }
      return [];
    }
  },
  methods: {
    escapeKeyListener(evt) {
      if (evt.keyCode === 27) {
        this.ismodal = false;
      }
    },
    filter(id) {
      this.selectedCategory = id;
    },

    // Open the Modal
    openModal(id) {
      this.ismodal = true;
      this.slideIndex = id;
      document.addEventListener("keyup", this.escapeKeyListener);
    },

    // Close the Modal
    closeModal() {
      this.ismodal = false;
      this.slideIndex = 1;
      document.removeEventListener("keyup", this.escapeKeyListener);
    },

    // Next/previous controls
    plusSlides(n) {
      if (this.slideIndex + n > this.selectedImages.length) {
        this.slideIndex = 1;
      } else if (this.slideIndex + n < 1) {
        this.slideIndex = this.selectedImages.length;
      } else {
        this.slideIndex += n;
      }
    }
  }
};
</script>
